import React from 'react'
import PropTypes from 'prop-types'

const BarCodeSection = ({ creditName, creditValue, pointsValue }) => (
  <div className='col-9  txt-left  justify-content-center align-self-center'>
    <p className='txt-body-sm txt-font-body color-ui-2'>
      Crédito: <strong>{creditName || 'Shell Box'}</strong>
    </p>
    <p className='txt-body-sm  txt-font-body color-ui-2'>
      Valor em créditos: <strong> {creditValue} </strong>
    </p>
    <p className='txt-body-sm txt-font-body color-ui-2'>
      Valor em reales: <strong>{pointsValue} </strong>
    </p>
  </div>
)

BarCodeSection.propTypes = {
  creditName: PropTypes.string,
  creditValue: PropTypes.number,
  pointsValue: PropTypes.number
}

export default BarCodeSection



// WEBPACK FOOTER //
// ./src/features/FuelCredit/Sidebar/FuelCreditSection.js